import { c as _c } from "react/compiler-runtime";
import { AdvertiserDisclosure } from '@cc-shopping/ui/composites/AdvertiserDisclosure';
import { Box } from '@mui/material';
import React from 'react';
import { BreadcrumbRedesigned } from 'src/features/navigation/BreadcrumbRedesigned';
import BelowSections from './BelowSections';
import ComparisonSection from './ComparisonSection';
import Filter from './Filter';
import Header from './Header';
export default function Compare() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      paddingTop: 3
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Box mx={2} display="flex" flexDirection="column" gap={2}><BreadcrumbRedesigned source="COMPARE" slug="" text="Select the cards you'd like to compare" /><AdvertiserDisclosure position="bottom-left" /><Header title="Select the cards you'd like to compare" subtitle="Search or browse the categories below" /></Box>;
    t2 = <Filter marginTop={6} />;
    t3 = <ComparisonSection marginTop={2} />;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Box sx={t0}>{t1}{t2}{t3}<BelowSections marginTop={8} marginBottom={6} mx={{
        xs: 3,
        lg: 0
      }} /></Box>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}